module.exports = __webpack_public_path__ + "img/equipment-active.5562e4d8.svg";